import { defineMessages } from 'react-intl';
export default defineMessages({
  ActivateValidateApplicationuseOtherPNtoActivate: {
    id: 'ActivateValidateApplication.useOtherPNtoActivate',
    defaultMessage: '该手机号已与其它微信号绑定过，请在对应微信号内或使用其他手机号激活',
  },
  ActivateValidateApplicationConfirm: {
    id: 'ActivateValidateApplication.Confirm',
    defaultMessage: '确定',
  },
  AddressListApplicationaddAddressPrompt: {
    id: 'AddressListApplication.addAddressPrompt',
    defaultMessage: '主人还没有收货地址，快来添加一个吧～',
  },
  AddressListApplicationaddAddressPrompt2: {
    id: 'AddressListApplication.addAddressPrompt2',
    defaultMessage: '主人还没有收货地址',
  },
  AddressListApplicationaddAddressPrompt3: {
    id: 'AddressListApplication.addAddressPrompt3',
    defaultMessage: '快来添加一个吧～',
  },
  AddressListApplicationdeleteToModifyAddress: {
    id: 'AddressListApplication.deleteToModifyAddress',
    defaultMessage: '如需新增，请删除或修改已有地址',
  },
  AddressListApplicationaddAddress: {
    id: 'AddressListApplication.addAddress',
    defaultMessage: '新增地址',
  },
  BindAlipayApplicationAliPay: {
    id: 'BindAlipayApplication.AliPay',
    defaultMessage: '支付宝',
  },
  BindWXApplicationWXID: {
    id: 'BindWXApplication.WXID',
    defaultMessage: '微信号',
  },
  BookCheckOrderApplicationunknownShop: {
    id: 'BookCheckOrderApplication.unknownShop',
    defaultMessage: '未知的门店',
  },
  BookCheckOrderApplicationselectedGoods: {
    id: 'BookCheckOrderApplication.selectedGoods',
    defaultMessage: '已选商品',
  },
  BookCheckOrderApplicationtotalGoods: {
    id: 'BookCheckOrderApplication.totalGoods',
    defaultMessage: '共{dishesCount}份',
  },
  BookCheckOrderApplicationmodifyOrder: {
    id: 'BookCheckOrderApplication.modifyOrder',
    defaultMessage: '修改订单',
  },
  BookCheckOrderApplicationTotal: {
    id: 'BookCheckOrderApplication.Total',
    defaultMessage: '总计：',
  },
  BookCheckOrderApplicationPS: {
    id: 'BookCheckOrderApplication.PS',
    defaultMessage: '备注',
  },
  BookCheckOrderApplicationconfirmMenu: {
    id: 'BookCheckOrderApplication.confirmMenu',
    defaultMessage: '确认菜单',
  },
  BookDetailApplicationshowMenu: {
    id: 'BookDetailApplication.showMenu',
    defaultMessage: '查看菜单',
  },
  BookDetailApplicationadvanceDish: {
    id: 'BookDetailApplication.advanceDish',
    defaultMessage: '预点菜',
  },
  BookDetailApplicationgotoPay: {
    id: 'BookDetailApplication.gotoPay',
    defaultMessage: '去支付',
  },
  BookDetailApplicationcancelOrder: {
    id: 'BookDetailApplication.cancelOrder',
    defaultMessage: '取消订单',
  },
  BookDetailApplicationCancelBook: {
    id: 'BookDetailApplication.CancelBook',
    defaultMessage: '取消预定',
  },
  BookDetailApplicationConfirmToshop: {
    id: 'BookDetailApplication.ConfirmToshop',
    defaultMessage: '确定到店',
  },
  BookDetailApplicationConfirmComeInTime: {
    id: 'BookDetailApplication.ConfirmComeInTime',
    defaultMessage: '请确认是否准时到店',
  },
  BookDetailApplicationAdvanced: {
    id: 'BookDetailApplication.Advanced',
    defaultMessage: '已付订金',
  },
  BrandIndexApplicationCancelBookPrompt: {
    id: 'BrandIndexApplication.CancelBookPrompt',
    defaultMessage: '取消预订后，商户将不会为您保留位置，请确认',
  },
  BrandIndexApplicationNeedAdvance: {
    id: 'BrandIndexApplication.NeedAdvance',
    defaultMessage: '需付订金',
  },
  BrandIndexApplicationAdvancedPrompt: {
    id: 'BrandIndexApplication.AdvancedPrompt',
    defaultMessage: '您已付预付金，不支持在线取消，请联系商户',
  },
  BrandIndexApplicationBookInfo: {
    id: 'BrandIndexApplication.BookInfo',
    defaultMessage: '预订信息',
  },
  BrandIndexApplicationOrderId: {
    id: 'BrandIndexApplication.OrderId',
    defaultMessage: '订单编号',
  },
  BrandIndexApplicationBookTime: {
    id: 'BrandIndexApplication.BookTime',
    defaultMessage: '预订时间',
  },
  BrandIndexApplicationTableType: {
    id: 'BrandIndexApplication.TableType',
    defaultMessage: '桌台类型',
  },
  BrandIndexApplicationBookPeople: {
    id: 'BrandIndexApplication.BookPeople',
    defaultMessage: '预订人数',
  },
  BrandIndexApplicationConnectPerson: {
    id: 'BrandIndexApplication.ConnectPerson',
    defaultMessage: '联  系 人',
  },
  BrandIndexApplicationConnectWay: {
    id: 'BrandIndexApplication.ConnectWay',
    defaultMessage: '联系方式',
  },
  BrandIndexApplicationPS: {
    id: 'BrandIndexApplication.PS',
    defaultMessage: '备      注',
  },
  CombinedPaymentorderChanged: {
    id: 'CombinedPayment.orderChanged',
    defaultMessage: '服务员修改了订单',
  },
  CombinedPaymentplsInputVipTradePW: {
    id: 'CombinedPayment.plsInputVipTradePW',
    defaultMessage: '请输入会员交易密码',
  },
  CombinedPaymentWXPay: {
    id: 'CombinedPayment.WXPay',
    defaultMessage: '微信支付',
  },
  CombinedPaymentAliPay: {
    id: 'CombinedPayment.AliPay',
    defaultMessage: '支付宝支付',
  },
  CombinedPaymentAntCreditPay: {
    id: 'CombinedPayment.AntCreditPay',
    defaultMessage: '花呗支付',
  },
  CombinedPaymentAntCredit: {
    id: 'CombinedPayment.AntCredit',
    defaultMessage: '花呗分期',
  },
  CombinedPaymentAntCreditFee: {
    id: 'CombinedPayment.AntCreditFee',
    defaultMessage: '服务费{fee}元/期',
  },
  uePayBtn: {
    id: 'CombinedPayment.uePay',
    defaultMessage: '極易付支付',
  },
  bocPayBtn: {
    id: 'CombinedPayment.bocPay',
    defaultMessage: '澳門中銀手機銀行支付',
  },
  mPayBtn: {
    id: 'CombinedPayment.mPayBtn',
    defaultMessage: 'MPay 支付',
  },
  touchngoPayBtn: {
    id: 'CombinedPayment.touchngoPay',
    defaultMessage: 'TNG 支付',
  },
  PayDetailBrandApplicationOtherPay: {
    id: 'CombinedPayment.OtherPay',
    defaultMessage: '第三方支付',
  },
  CombinedPaymentPaySuccess: {
    id: 'CombinedPayment.PaySuccess',
    defaultMessage: '支付成功',
  },
  CustomerAddressApplicationinputReceiveAddress: {
    id: 'CustomerAddressApplication.inputReceiveAddress',
    defaultMessage: '请输入收货位置',
  },
  DishMenuApplicationmircAppUnOpen: {
    id: 'DishMenuApplication.mircAppUnOpen',
    defaultMessage: '该门店未开通小程序业务',
  },
  DishMenuApplicationgotoRegister: {
    id: 'DishMenuApplication.gotoRegister',
    defaultMessage: '去注册',
  },
  DishMenuApplicationregisterToGetGift: {
    id: 'DishMenuApplication.registerToGetGift',
    defaultMessage: '注册会员享受更多福利哟～',
  },
  DishMenuApplicationgetSpecialGift: {
    id: 'DishMenuApplication.getSpecialGift',
    defaultMessage: '恭喜获得评价专属礼包',
  },
  DishMenuApplicationgetSpecialGiftSuccess: {
    id: 'DishMenuApplication.getSpecialGiftSuccess',
    defaultMessage: '成功领取专属礼包',
  },
  QueueDetailApplicationlineUpToOrder: {
    id: 'QueueDetailApplication.lineUpToOrder',
    defaultMessage: '排队点菜',
  },
  OrderInlineApplicationoccluedMobileShop: {
    id: 'OrderInlineApplication.occluedMobileShop',
    defaultMessage: '当前门店未开通移动门店，请联系商户',
  },
  PayDetailApplicationchoosePayWay: {
    id: 'PayDetailApplication.choosePayWay',
    defaultMessage: '请选择支付方式',
  },
  BrandIndexApplicationshopInfo: {
    id: 'BrandIndexApplication.shopInfo',
    defaultMessage: '门店信息',
  },
  BrandIndexApplicationwaitInfo: {
    id: 'BrandIndexApplication.waitInfo',
    defaultMessage: '前方等待{count}桌',
  },
  BrandIndexApplicationnetErr: {
    id: 'BrandIndexApplication.netErr',
    defaultMessage: '当前网络不佳，请稍后再试',
  },
  BrandIndexApplicationnotWait: {
    id: 'BrandIndexApplication.notWait',
    defaultMessage: 'POS机当前未联网，无法排队取号',
  },

  BookCheckOrderTotal: {
    id: 'BookCheckOrder.Total',
    defaultMessage: '共{dishCount}份',
  },
  QueueDetailWait: {
    id: 'QueueDetail.Wait',
    defaultMessage: '在您之前还有{count}桌客人等候',
  },
  QueueDetailYouCan: {
    id: 'QueueDetail.YouCan',
    defaultMessage: '您可以',
  },
  editAddress: {
    id: 'editAddress',
    defaultMessage: '编辑地址',
  },
  AddAddress: {
    id: 'AddAddress',
    defaultMessage: '新增地址',
  },
  queueDetailGetNumber: {
    id: 'queueDetailGetNumber',
    defaultMessage: '取号',
  },
  isPaymentCompleted: {
    id: 'isPaymentCompleted',
    defaultMessage: '是否完成支付？',
  },
  paymentComplete: {
    id: 'paymentComplete',
    defaultMessage: '已完成支付',
  },
  paymentRetry: {
    id: 'paymentRetry',
    defaultMessage: '重新支付',
  },
  systemException: {
    id: 'systemException',
    defaultMessage: '系统异常',
  },
  loginFailed: {
    id: 'loginFailed',
    defaultMessage: '登录异常，不可点餐',
  },
  dishMenuTestButton: {
    id: 'dishMenuTestButton',
    defaultMessage: '商品信息变更，请核对下单',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/container/part1/index.js